export default "__VITE_ASSET__c5z4KAUw__"